<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div id="sbg-content-container" class="relative flex justify-center max-w-5xl mx-auto clearfix" v-show="categories.length > 0">
      <div class="flex-1" v-show="loaded">
        <div class="z-50 sticky top-0">
          <!-- HEADER -->
          <div class="flex items-center h-20" style="background-color: #F8F8F8;">
            <div class="lg:hidden mt-2 h-full w-12 content-center items-center" style="background-color: #1F205A;" @click="activateSidebar">
              <span class="flex text-white my-2 mx-1 content-center items-center z-50"><vs-icon icon="menu" size="medium"/></span>
            </div>
            <div class="hidden lg:flex ml-4 mt-1 cursor-pointer" @click="goHome">
              <img src="@/assets/images/logo/LogoFull.png" height="70" alt="SBG">
            </div>
<!--            <div class="lg:hidden flex mt-1 mx-2 cursor-pointer" @click="goHome">-->
<!--              <img src="@/assets/images/logo/Logo.png" height="40" alt="SBG">-->
<!--            </div>-->

            <!-- SEARCH BAR -->
            <div class="flex-1 items-center mt-2 mx-1 sm:mx-4 md:mx-10 lg:mx-32 xl:mx-64">
              <div class="relative my-4">

                <!-- SEARCH INPUT -->
                <vs-input :success="true" class="w-full border border-success rounded-l" placeholder="Buscar..." :value="currentRefinement" @input="refine($event)" @keyup.esc="refine('')" size="large"/>

                <!-- SEARCH ICON -->
                <div slot="submit-icon" class="hidden sm:block absolute top-0 right-0 py-3 px-6 bg-success rounded-r" style="height: 50px;" v-show="!currentRefinement">
                  <feather-icon icon="SearchIcon" svgClasses="h-6 w-6 text-white"/>
                </div>

                <!-- CLEAR INPUT ICON -->
                <div slot="reset-icon" class="absolute top-0 right-0 py-6 px-6" v-show="currentRefinement">
                  <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer" @click="refine('')"/>
                </div>
              </div>
            </div>
            <div class="border border-solid border-success rounded-l-lg px-2 text-md h-12 flex items-center text-xs sm:text-md"><div>Q{{ total.toFixed(2) }}</div></div>
            <div class="border border-l-0 border-solid border-success rounded-r-lg px-2 text-sm h-12 flex items-center">
              <span class="hidden lg:block">Carrito</span> <cart-drop-down/>
            </div>
          </div>

          <!-- CATEGORIES IN LARGE SCREENS -->
          <div class="items-center mx-1">
            <div class="hidden lg:flex lg:h-16 lg:mx-1 items-center bg-primary">
              <div class="h-full flex-1 ml-px bg-primary"/>
              <div class="h-full flex ml-px text-white" v-bind:style="{'background-color': categoryColor(null)}">
                <span class="mx-10 text-2xl font-extrabold my-auto cursor-pointer" @click="goHome">Inicio</span>
              </div>
              <div
                v-for="category in mainCategories"
                :key="category.id"
                class="h-full flex ml-px hover:bg-gray-500"
                v-bind:style="{'background-color': categoryColor(category)}"
                @mouseover="hoverCategory = category" @mouseleave="hoverCategory = null"
              >
                <span class="mx-10 text-2xl font-extrabold my-auto cursor-pointer text-white" @click="toCategory(category)">{{ category.name }}</span>
                <div style="width: 20rem; position: absolute; display: inline-block; top: 10.5rem; z-index: 1000; background-color: #FFF; margin-left: 2rem;" v-show="showSubcategories(category)">
              <span
                v-for="subCategory in subCategories(category)"
                :key="subCategory.id"
                @click="toCategory(subCategory)"
                class="flex p-6 m-px text-lg cursor-pointer text-white"
                id="sbg-sub-c"
              >
                {{ subCategory.name }}<br/>
              </span>
                </div>
              </div>
              <div class="h-full flex-1 ml-px bg-primary"/>
            </div>
          </div>
        </div>

        <!-- BREADCRUMBS -->
        <div class="flex items-start h-6 lg:h-4 ml-4 mt-1" v-if="inProductsScreen || inItemScreen">
            <span class="flex items-center cursor-pointer" @click="goHome">
              <vs-icon icon="home" size="1.7rem" class="mr-2"/>
              <span class="lg:text-lg">Inicio</span>
            </span>
          <span class="flex items-center cursor-pointer" v-for="breadcrumb in breadcrumbs" :key="breadcrumb.title" @click="toCategory(breadcrumb.category)">
              <vs-icon icon="keyboard_arrow_right" size="small"/>
              <span class="lg:text-lg">{{ breadcrumb.title }}</span>
            </span>
        </div>

        <div id="sbg-main-container">
          <!-- HOME SCREEN - HIGHLIGHTED PRODUCTS -->
          <home class="mt-0 mx-2" v-if="inHomeScreen"/>

          <!-- PRODUCTS SCREEN -->
          <div v-show="inProductsScreen">

            <!-- SEARCH RESULT -->
            <div class="flex my-4 ml-4">
              <div class="hidden lg:flex lg:mr-4 lg:vx-col items-no-padding background-absolute" style="width: 280px;">
                <vx-card no-shadow no-radius>
                  <div class="p-2 filter-container">
                    <h6 class="font-bold mb-3 text-primary">Categorías</h6>
                    <div @click="setCategory(null)" class="flex items-center cursor-pointer py-1">
                      <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': !selectedCategory}, 'h-5 w-5']"/>
                      <span class="ml-2" :class="{'text-primary': !selectedCategory}">Todas</span>
                    </div>
                    <div v-for="item in mainCategories" :key="item.id">
                      <div @click="toCategory(item)" class="flex items-center cursor-pointer py-1">
                        <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedCategory && item.id == selectedCategory.id}, 'h-5 w-5']"/>
                        <span class="ml-2" :class="{'text-primary': selectedCategory && item.id == selectedCategory.id}">{{ item.name }}</span>
                      </div>
                      <div v-for="subCategory in subCategories(item)" :key="subCategory.id" class="flex ml-6 text-md">
                        <div @click="toCategory(subCategory)" class="flex items-center cursor-pointer py-1 text-sm">
                          <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedCategory && subCategory.id == selectedCategory.id}, 'h-5 w-5']"/>
                          <span class="ml-2" :class="{'text-primary': selectedCategory && subCategory.id == selectedCategory.id}">{{ subCategory.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <vs-divider/>

                  <div class="p-2 filter-container">
                    <h6 class="font-bold mb-3 text-primary">Versiones</h6>
                    <ul>
                      <li class="flex items-center cursor-pointer py-1 text-sm" @click="refineVersion(null)">
                        <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': !selectedVersion}, 'h-5 w-5']"/>
                        <span class="ml-2" :class="{'text-primary': !selectedVersion}">Todas</span>
                      </li>
                      <li
                        v-for="item in versions"
                        :key="item.id"
                        class="flex items-center cursor-pointer py-1 text-sm"
                        @click="refineVersion(item)">

                        <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedVersion && item.id == selectedVersion.id}, 'h-5 w-5']"/>
                        <span class="ml-2" :class="{'text-primary': selectedVersion && item.id == selectedVersion.id}">{{ item.name }}</span>
                      </li>
                    </ul>
                  </div>

                  <vs-divider/>

                  <div class="p-2 filter-container">
                    <h6 class="font-bold mb-3 text-primary">Rango de precios:</h6>
                    <ul>
                      <li class="flex items-center cursor-pointer py-1 text-sm" @click="refinePriceRange(null)">
                        <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': !selectedPriceRange}, 'h-5 w-5']"/>
                        <span class="ml-2" :class="{'text-primary': !selectedPriceRange}">Todos</span>
                      </li>
                      <li
                        v-for="item in priceRanges"
                        :key="item.id"
                        class="flex items-center cursor-pointer py-1"
                        @click="refinePriceRange(item)">

                        <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedPriceRange && item.id == selectedPriceRange.id}, 'h-5 w-5']"/>
                        <span class="ml-2" :class="{'text-primary': selectedPriceRange && item.id == selectedPriceRange.id}">{{ item.label }}</span>
                      </li>
                    </ul>
                  </div>

                  <vs-divider/>

                  <div class="flex justify-center">
                    <vs-button class="w-full" @click.prevent="clearFilters">Eliminar filtros</vs-button>
                  </div>
                </vx-card>
              </div>

              <!-- GRID VIEW -->
              <!--              <template>-->
              <div class="flex-1 mr-4">
                <!--                                  <component :is="scrollbarTag" ref="mainSidebarPs" class="p-0 max-h-screen" :settings="settings" :key="$vs.rtl">-->
                <!--                  <div>-->
                <!--                  <vue-perfect-scrollbar class="scroll-area" v-once :settings="settings" @ps-scroll-y="scrollHandle">-->
                <div class="items-grid-view vx-row match-height">
                  <div class="vx-col w-full sm:w-1/2 xl:w-1/3" v-for="item in products" :key="item.id">

                    <item-grid-view :item="item">

                      <!-- SLOT: ACTION BUTTONS -->
                      <template slot="action-buttons">
                        <div class="flex flex-wrap">

                          <!-- PRIMARY BUTTON: ADD TO WISH LIST -->
                          <div class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer">

                            <span v-if="item.onSale === false" class="text-xl font-bold ml-2 text-warning"><b>Q{{ item.price.toFixed(2) }}</b></span>
                            <span v-else class="text-xl font-bold ml-2">Q{{ item.price.toFixed(2) }}</span>
                          </div>

                          <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                          <div v-if="isInCart(item.id)"
                               class="item-view-secondary-action-btn bg-warning p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                               @click="cartButtonClicked(item)">
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4"/>

                            <span class="text-sm font-semibold ml-2">VER EN PEDIDO</span>
                          </div>
                          <div v-else
                               :class="`item-view-secondary-action-btn ${item.available ? 'bg-success' : 'bg-primary'} p-3 flex flex-grow items-center justify-center text-white cursor-pointer`"
                               @click="cartButtonClicked(item)">
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" v-if="item.available"/>
                            <feather-icon icon="XSquareIcon" svgClasses="h-4 w-4" v-else/>

                            <span class="text-sm font-semibold ml-2" v-if="item.available">AGREGAR</span>
                            <span class="text-sm font-semibold ml-2" v-else>NO DISPONIBLE</span>
                          </div>
                        </div>
                      </template>
                    </item-grid-view>

                  </div>
                  <div class="content-area__content">
                    <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500">
                      <vs-button radius icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" color="success"/>
                    </back-to-top>
                  </div>
                </div>
                <!--                  </vue-perfect-scrollbar>-->
                <!--                  </div>-->
                <!-- SCROLL TO TOP BUTTON -->
                <!--                                  </component>-->
              </div>
              <!--              </template>-->
            </div>
          </div>

          <item-detail-view class="mt-4" v-if="inItemScreen"/>

          <profile class="mt-4 mx-1" v-if="inProfileScreen"/>

          <check-out class="mt-4" v-if="inCheckoutScreen"/>

          <shipping-terms class="mt-4" v-if="inShippingScreen"/>

          <learn class="mt-4" v-if="inLearnScreen"/>

          <donate class="mt-4" v-if="inDonateScreen"/>

          <div>
            <div class="m-4 flex flex-wrap justify-between">
              <div class="m-2">
                <img src="@/assets/images/logo/LogoFull.png" height="90" alt="SBG" class="mb-2">
                <div class="flex justify-start items-center mb-2">
                  <vs-icon icon="store" size="medium" class="mr-2"/>
                  <div class="flex flex-col">
                    <div>11 calle 6-67 zona 9</div>
                    <div>Guatemala, Guatemala</div>
                  </div>
                </div>
                <a href="tel:+50223808500" class="flex justify-start items-center mb-2">
                  <vs-icon icon="phone" size="medium" class="mr-2"/>
                  <div class="flex flex-col">
                    <div>(502) 2380 8500</div>
                  </div>
                </a>
                <a href="https://wa.me/50259789090" target="_blank" class="flex justify-start items-center mb-2">
                  <img src="@/assets/images/pages/eCommerce/whatsapp.png" alt="whatsapp" class="ml-1 mr-3" height="26">
                  <div class="flex flex-col">
                    <div>(502) 5978 9090</div>
                  </div>
                </a>
              </div>
              <div class="my-2 ml-2 lg:ml-8 mr-2">
                <div class="text-bold text-2xl flex items-end mb-3" style="height: 90px;"><b>Centro de distribución</b></div>
                <div class="flex justify-start items-center mb-2">
                  <vs-icon icon="store" size="medium" class="mr-2"/>
                  <div class="flex flex-col">
                    <div>17 Av. 3-17 Zona 3, Plaza Atlantis local B</div>
                    <div>Quetzaltenango, Guatemala</div>
                  </div>
                </div>
                <a href="tel:+50277614144" class="flex justify-start items-center mb-2">
                  <vs-icon icon="phone" size="medium" class="mr-2"/>
                  <div class="flex flex-col">
                    <div>(502) 7761 4144</div>
                  </div>
                </a>
                <a href="https://wa.me/50256211095" target="_blank" class="flex justify-start items-center mb-2">
                  <img src="@/assets/images/pages/eCommerce/whatsapp.png" alt="whatsapp" class="ml-1 mr-3" height="26">
                  <div class="flex flex-col">
                    <div>(502) 5621 1095</div>
                  </div>
                </a>
              </div>
              <div class="my-2 ml-2 lg:ml-8 mr-2">
                <div class="text-bold text-2xl flex items-end mb-3" style="height: 90px;"><b>Políticas</b></div>
                <div class="flex justify-start items-center mb-2">
                  <vs-icon icon="arrow_right" size="small"/>
                  <div class="flex flex-col">
                    Términos de servicio
                  </div>
                </div>
                <div class="flex justify-start items-center mb-2">
                  <vs-icon icon="arrow_right" size="small"/>
                  <div class="flex flex-col">
                    <router-link to="/shipping">Póliticas de envío</router-link>
                  </div>
                </div>
              </div>
              <vs-spacer/>
              <div class="my-auto ml-2 mr-8">
<!--                <div class="text-bold text-2xl flex items-end my-6">
                  <a href="https://facebook.com/CasaDeLaBibliaGuatemala" target="_blank" class="text-bold text-lg lg:text-2xl flex items-center mb-3 h-full">
                    <vs-icon icon-pack="feather" icon="icon-facebook" size="medium" class="mr-2"/>
                    <div class="flex flex-col">
                      @CasaDeLaBibliaGuatemala
                    </div>
                  </a>
                </div>
-->
                <div class="flex flex-col justify-start items-center mb-2">
                  <img src="@/assets/images/logo/LogoSBG.png" alt="SBG" class="h-32">
                  <div class="flex flex-col">
                    Casa de la Biblia es parte de
                    <div class="flex flex-col">
                      <a href="https://SBiblica.org" target="_blank">Sociedad Bíblica de Guatemala</a>
                    </div>
                  </div>
                </div>
                <!--                <div class="flex item-center mb-4 text-sm">-->
                <!--                  <vs-button @click="productsLoad">Load</vs-button>-->
                <!--                  <vs-button @click="productsImport">Import</vs-button>-->
                <!--                </div>-->
              </div>
            </div>
          </div>
        </div>

        <!-- SIDEBAR FOR SMALL SCREENS -->
        <vs-sidebar class="lg:hidden" parent="#sbg-main-container" default-index="1" color="primary" spacer v-model="sidebarActive" :hidden-background="true">
          <div class="ml-4">
            <div class="flex items-center justify-between">
              <h6 class="font-bold mb-3">Categorías</h6>
              <feather-icon icon="XCircleIcon" class="mr-2 cursor-pointer text-danger" size="3x" @click="sidebarActive = false"/>
            </div>
            <div @click="setCategory(null)" class="flex items-center cursor-pointer py-1">
              <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': !selectedCategory}, 'h-5 w-5']"/>
              <span class="ml-2" :class="{'text-primary': !selectedCategory}">Todas</span>
            </div>
            <div v-for="item in mainCategories" :key="item.id">
              <div @click="toCategory(item)" class="flex items-center cursor-pointer py-1">
                <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedCategory && item.id == selectedCategory.id}, 'h-5 w-5']"/>
                <span class="ml-2" :class="{'text-primary': selectedCategory && item.id == selectedCategory.id}">{{ item.name }}</span>
              </div>
              <div v-for="subCategory in subCategories(item)" :key="subCategory.id" class="flex ml-6 text-md">
                <div @click="toCategory(subCategory)" class="flex items-center cursor-pointer py-1 text-sm">
                  <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedCategory && subCategory.id == selectedCategory.id}, 'h-5 w-5']"/>
                  <span class="ml-2" :class="{'text-primary': selectedCategory && subCategory.id == selectedCategory.id}">{{ subCategory.name }}</span>
                </div>
              </div>
            </div>
          </div>

          <vs-divider/>

          <div class="ml-4">
            <h6 class="font-bold mb-3">Versiones</h6>
            <ul>
              <li class="flex items-center cursor-pointer py-1 text-sm" @click="refineVersion(null)">
                <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': !selectedVersion}, 'h-5 w-5']"/>
                <span class="ml-2" :class="{'text-primary': !selectedVersion}">Todas</span>
              </li>
              <li
                v-for="item in versions"
                :key="item.id"
                class="flex items-center cursor-pointer py-1 text-sm"
                @click="refineVersion(item)">

                <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedVersion && item.id == selectedVersion.id}, 'h-5 w-5']"/>
                <span class="ml-2" :class="{'text-primary': selectedVersion && item.id == selectedVersion.id}">{{ item.name }}</span>
              </li>
            </ul>
          </div>

          <vs-divider/>

          <div class="flex justify-center mx-4">
            <vs-button class="w-full" @click.prevent="clearFilters">Eliminar filtros</vs-button>
          </div>
        </vs-sidebar>
      </div>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue';
  import {Carousel, Slide} from 'vue-carousel';
  import {IKImage} from "imagekitio-vue";
  import BackToTop from 'vue-backtotop';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import VueFbCustomerChat from 'vue-fb-customer-chat';
  /*
    import {db} from '@/firebaseConfig';
    import productsImport from '@/productsImport.json';
  */
  Vue.use(VueFbCustomerChat, {
    page_id: 'casadelabibliaguatemala', //  change 'null' to your Facebook Page ID,
    theme_color: '#1672E6', // theme color in HEX
    locale: 'es_GT', // default 'en_US'
  });

  export default {
    components: {
      Carousel,
      Slide,
      IKImage,
      BackToTop,
      VuePerfectScrollbar,
      Home: () => import('./Home'),
      ItemGridView: () => import('./components/ItemGridView'),
      ItemListView: () => import('./components/ItemListView'),
      ItemDetailView: () => import('./ECommerceItemDetailView'),
      CheckOut: () => import('./ECommerceCheckout'),
      SpecialOptionsView: () => import('./components/CouponView'),
      CartDropDown: () => import('./components/CartDropDown'),
      User: () => import('./components/User'),
      Profile: () => import('./pages/Profile'),
      ShippingTerms: () => import('./ShippingTerms'),
      Learn: () => import('./Learn'),
      Donate: () => import('./Donations')
    },
    props: ['categoryId'],
    data() {
      return {
        loaded: false,
        publicKey: '',
        urlEndpoint: '',
        sidebarActive: false,
        breadcrumbs: [],
        isFilterSidebarActive: true,
        clickNotClose: true,
        refinementSearchValue: '',
        currentRefinement: '',
        currentItemView: 'item-grid-view',
        specialSelected: false,
        showSpecialOptions: false,
        specialOptions: null,
        hoverCategory: null,
        pricesRange: [],
        migrationList: [],
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60
        }
      }
    },
    watch: {
      loaded(loaded) {
        if (loaded) {
          if (this.categories.length > 0) {
            if (this.categoryId > 0) {
              var category = this.categories.find(o => o.id === this.categoryId);
              if (category) {
                this.setCategory(category);
              }
            }
          }
        }
      },
      categoryId(categoryId) {
        alert(categoryId);
      },
      '$route.path': function () {
        this.validateRoute(this.$route);
      }
    },
    computed: {
      toValue() {
        return (value, range) => [
          value.min !== null ? value.min : range.min,
          value.max !== null ? value.max : range.max
        ]
      },

      // GRID VIEW
      isInCart() {
        return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
      },
      windowWidth() {
        return this.$store.state.windowWidth
      },

      activeUserInfo() {
        return this.$store.state.AppActiveUser;
      },

      priceRanges() {
        if (this.$store.state.priceRanges) {
          if (this.$store.state.priceRanges.list) {
            return [...this.$store.state.priceRanges.list].sort(function (a, b) {
              var ret = 1;
              if (a.sequence < b.sequence) {
                ret = -1;
              }
              return ret;
            });
          } else {
            return [];
          }
        } else {
          return [];
        }
      },

      versions() {
        if (this.$store.state.versions) {
          if (this.$store.state.versions.list) {
            return [...this.$store.state.versions.list].sort(function (a, b) {
              var ret = 1;
              if (a.sequence < b.sequence) {
                ret = -1;
              }
              return ret;
            });
          } else {
            return [];
          }
        } else {
          return [];
        }
      },

      categories() {
        if (this.$store.state.categories) {
          if (this.$store.state.categories.list) {
            return [...this.$store.state.categories.list].sort(function (a, b) {
              var ret = 1;
              if (a.sequence < b.sequence) {
                ret = -1;
              }
              return ret;
            });
          } else {
            return [];
          }
        } else {
          return [];
        }
      },

      inHomeScreen() {
        return (this.$store.state.homeScreen == 1);
      },

      inProductsScreen() {
        return (this.$store.state.homeScreen == 2);
      },

      inItemScreen() {
        return (this.$store.state.homeScreen == 3);
      },

      inCheckoutScreen() {
        return (this.$store.state.homeScreen == 4);
      },

      inProfileScreen() {
        return (this.$store.state.homeScreen == 6);
      },

      inShippingScreen() {
        return (this.$store.state.homeScreen == 7);
      },

      inLearnScreen() {
        return (this.$store.state.homeScreen == 9);
      },

      inDonateScreen() {
        return (this.$store.state.homeScreen == 10);
      },

      selectedPriceRange() {
        return this.$store.state.priceRange;
      },

      selectedVersion() {
        return this.$store.state.version;
      },

      selectedCategory() {
        return this.$store.state.selectedCategory;
      },

      products() {
        return this.$store.getters['refinedProductsList'];
        // return this.refine();
      },

      mainCategories() {
        if (this.categories) {
          return this.categories.filter(function (category) {
            return category.parentId == '';
          }).sort(function (a, b) {
            if (a.sequence > b.sequence) {
              return 1;
            } else {
              return -1;
            }
          });
        } else {
          return [];
        }
      },
      scrollbarTag() {
        return this.$store.getters.scrollbarTag
      },
      cartItems () {
        return this.$store.state.eCommerce.cartItems;
      },
      total() {
        if (this.cartItems.length > 0) {
          return this.cartItems.map(item => item.amount).reduce((prev, next) => prev + next);
        } else {
          return 0;
        }
      }
    },
    methods: {
      /*
            productsLoad() {
              this.migrationList = [];
              var self = this;
              var product;
              for (var i = 0; i < productsImport.Productos.length; i++) {
                product = productsImport.Productos[i];
                db.collection('products')
                  .where('isbn', '==', product.isbn)
                  .get()
                  .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                      if (doc.exists) {
                        // db.collection('products').doc(doc.id).update({
                        //   categoryId: parseInt(product.categoryId),
                        //   name: product.name.trim(),
                        //   price: parseFloat(product.price),
                        //   versionId: parseInt(product.versionId),
                        //   description: product.description.trim(),
                        //   categories: product.categories.trim(),
                        //   status: 'ACT',
                        //   available: true
                        // });
                        self.migrationList.push({id: doc.id, data: doc.data()});
                        // console.log(doc.id, '=>', doc.data);
                      }
                    });
                  })
                  .catch(function (error) {
                    console.log('Error: ', error);
                  });
              }
            },
      */
      /*
            productsImport() {
              var index;
              var product;
              for (var i = 0; i < this.migrationList.length; i++) {
                index = productsImport.Productos.findIndex(item => item.isbn == this.migrationList[i].data.isbn);
                if (index >= 0) {
                  product = productsImport.Productos[index];
                  this.migrationList[i].data = {
                    categoryId: parseInt(product.categoryId),
                    name: product.name.trim(),
                    price: parseFloat(product.price),
                    versionId: parseInt(product.versionId),
                    description: product.description.trim(),
                    categories: product.categories.trim(),
                    status: 'ACT',
                    available: true
                  }
                }
              }
              console.log('Migration: ', this.migrationList);
              for (i = 0; i < this.migrationList.length; i++) {
                product = this.migrationList[i].data;
                db.collection('products').doc(this.migrationList[i].id).update({
                  categoryId: parseInt(product.categoryId),
                  name: product.name.trim(),
                  price: parseFloat(product.price),
                  versionId: parseInt(product.versionId),
                  description: product.description.trim(),
                  categories: product.categories.trim(),
                  status: 'ACT',
                  available: true
                });
              }
            },
      */
      /*
            migrate() {
              db.collection('home').doc('showcaseProducts').update({list: this.$store.state.showcaseProducts});
            },
      */
      /*
            mig1() {
              this.migrationList = [];
              db.collection('products').get().then(querySnapshot => {
                const docs = querySnapshot.docs.map(doc => doc.data());
                console.log(docs);
                db.collection('catalogs').doc('products').update({list: docs});
              })
            },

      copy1() {
        db.collection('home').doc('showcaseTest').set({list: this.$store.state.showcaseProducts.list});
      },

      productsBackup() {
        const products = JSON.stringify(this.products);
        console.log(products);
      },
      */

      activateSidebar() {
        this.sidebarActive = true;
        window.scrollTo(0, 0);
      },

      validateRoute(route) {
        if (route.name == 'checkout') {
          this.$store.dispatch('updateHomeScreen', 4);
        } else if (route.name == 'category-view') {
          if (route.hasOwnProperty('params')) {
            if (route.params.hasOwnProperty('category')) {
              if (this.categories) {
                const category = this.categories.find(c => c.id == parseInt(route.params.category));
                if (category) {
                  this.setCategory(category);
                }
              }
            }
          }
        } else if (route.name == 'profile') {
          this.$store.dispatch('updateHomeScreen', 6);
        } else if (route.name == 'shipping') {
          this.$store.dispatch('updateHomeScreen', 7);
        } else if (route.name == 'learn') {
          this.$store.dispatch('updateHomeScreen', 9);
        } else if (route.name == 'donate') {
          this.$store.dispatch('updateHomeScreen', 10);
        } else if (route.hasOwnProperty('params')) {
          if (route.params.hasOwnProperty('item')) {
            this.$store.dispatch('updateHomeScreen', 3);
          }
        }
      },
      // GRID VIEW - ACTIONS
      toggleFilterSidebar() {
        if (this.clickNotClose) return
        this.isFilterSidebarActive = !this.isFilterSidebarActive
      },
      categoryColor(category) {
        let color = '#001d56';
        if (category == null) {
          if (this.selectedCategory == null) {
            color = '#0aafbc';
          }
        } else if (this.selectedCategory != null) {
          if (this.selectedCategory.id == category.id) {
            color = '#0aafbc';
          }
        }
        return color;
      },
      additemInCart(item) {
        this.$store.dispatch('eCommerce/additemInCart', item)
      },
      cartButtonClicked(item) {
        if (item.available) {
          if (item.combo) {
            this.specialOptions = JSON.parse(JSON.stringify(item));
            this.showSpecialOptions = true;
          } else {
            this.isInCart(item.id) ? this.$router.push('/checkout').catch(() => {
            }) : this.additemInCart(item);
          }
        }
      },
      subCategories(category) {
        if (this.categories) {
          return this.categories.filter(function (subCategory) {
            return category.subCategories.split(',').includes(subCategory.id);
          }).sort(function (a, b) {
            if (a.sequence > b.sequence) {
              return 1;
            } else {
              return -1;
            }
          });
        } else {
          return [];
        }
      },
      addCouponCart() {
        this.additemInCart(this.specialOptions);
      },

      toCategory(item) {
        this.$router.push({name: 'category-view', params: {category: item.id}}).catch(() => {});
      },

      setCategory(category) {
        this.$store.dispatch('updateProductSearch', '');
        this.currentRefinement = '';
        if (category == null) {
          this.$store.dispatch('updateSelectedCategory', category);
          this.breadcrumbs = [];
        } else {
          if (category.parentId == '') {
            if (this.hoverCategory) {
              this.hoverCategory = null;
            }
            this.$store.dispatch('updateSelectedCategory', category);
            this.breadcrumbs = [];
          } else {
            var parent = this.categories.find(item => item.id === category.parentId);
            this.$store.dispatch('updateSelectedCategory', category);
            this.hoverCategory = null;
            this.breadcrumbs = [{title: parent.name, category: parent}];
          }
          this.breadcrumbs.push({title: category.name, category: category});
        }
        if (!['home', 'category-view'].includes(this.$router.currentRoute.name) || category == null) {
          this.$router.push('/');
        }
        this.sidebarActive = false;
      },
      showSubcategories(category) {
        var show = false;
        if (this.hoverCategory) {
          if (this.hoverCategory.id == category.id) {
            show = true;
          }
        }
        return show;
      },
      refinePriceRange(item) {
        this.$store.dispatch('updateProductSearch', '');
        this.currentRefinement = '';
        this.$store.dispatch('updatePriceRange', item);
      },
      refineVersion(item) {
        this.$store.dispatch('updateProductSearch', '');
        this.currentRefinement = '';
        this.$store.dispatch('updateVersion', item);
      },
      refine(phrase) {
        this.$store.dispatch('updateSelectedCategory', null);
        this.$store.dispatch('updatePriceRange', null);
        this.$store.dispatch('updateVersion', null);
        this.$store.dispatch('updateProductSearch', phrase);
        this.currentRefinement = phrase;
      },
      clearFilters() {
        this.refineVersion(null);
        this.refinePriceRange(null);
        this.setCategory(null);
        this.refine('');
      },
      goHome() {
        this.clearFilters();
        this.$store.dispatch('updateHomeScreen', 1);
        this.$router.push('/');
      },
      scrollHandle(evt) {
        console.log(evt)
      },
      logout() {
        alert('logout');
      }
    },
    // created() {
    //   this.publicKey =  this.$store.getters['getParameter']('imagekit').publicKey;
    //   this.urlEndpoint =  this.$store.getters['getParameter']('imagekit').url + '/images/';
    // },
    mounted() {
      var self = this;
      setTimeout(function () {
        self.validateRoute(self.$route);
        self.loaded = true;
      }, 500);
    }
  }

</script>


<style lang="scss">
  #sbg-sub-c {
    background-color: #001d56;
    border: none;
    color: black;
    padding: 16px 32px;
    text-align: center;
    font-size: 16px;
    margin: 4px 2px;
    transition: 0.3s;
  }

  #sbg-sub-c:hover {
    background-color: #0aafbc;
    color: white;
  }

  #sbg-instant-search-demo {
    .sbg-header {
      .sbg-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #sbg-content-container {


      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .sbg-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .sbg-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #sbg-instant-search-demo {
      #sbg-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #sbg-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

  .scroll-area {
    position: relative;
    margin: auto;
    width: 400px;
    height: 300px;
  }

</style>

